export default "__VITE_ASSET__B9yNuJ8E__"